module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAdUlEQVQYlX3QsQ3CQBBE0XfYIS6DxKkDyoAuiCxThAswleAaiCAgdQWUQIpEcicBWvGTDeZLM9o0XjZn9HgIWGGPBQOqSIAGE27oIqHQ4ZrldSRAnesW7CKhkJAi4YUTWsz1T3jHId+vkU8csf0My6DZn0e9AWykErdQNNhdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/greensj.png
// module id = 1lkz
// module chunks = 15